<ng-container>
    <h2 mat-dialog-title class="dialog-header">
        <span class="dialog-title title-large">{{ 'customers.ui.ordinamento' | transloco }}</span>

        <button
            mat-icon-button
            type="button"
            [attr.aria-label]="'customers.ui.chiudi' | transloco"
            class="close-button"
            (click)="onClose()"
        >
            <i class="fa-regular fa-xmark"></i>
        </button>
    </h2>

    <mat-dialog-content class="content">
        <mat-radio-group [formControl]="sortControl" class="radio-group">
            <mat-radio-button value="ragioneSociale_asc">{{ 'customers.ui.ragioneSocialeAZ' | transloco }}</mat-radio-button>
            <mat-radio-button value="ragioneSociale_desc">{{ 'customers.ui.ragioneSocialeZA' | transloco }}</mat-radio-button>
        </mat-radio-group>
    </mat-dialog-content>

    <mat-dialog-actions class="buttons-container">
        <button matButton (click)="onReset()">{{ 'customers.ui.cancella' | transloco }}</button>
        <button matButton="filled" (click)="onApply()">{{ 'customers.ui.applica' | transloco }}</button>
    </mat-dialog-actions>
</ng-container>
